module.exports = __webpack_public_path__ + "static/scale-model-of-elephant-reserve-in-cincinnati-ohio-42fa1013d7d5dab2e15063987df224c1.png";